module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "untitled-1"
    }
  }, [_c('div', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal"
  }, [_c('br', {
    staticClass: "calibre1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "chapter-sub"
  }, [_vm._v("Also by William Florence: ")]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override"
  }, [_c('span', {
    staticClass: "no-style-override10"
  }, [_vm._v("The Max Blake Mystery series:")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override"
  }, [_c('span', {
    staticClass: "no-style-override10"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override"
  }, [_c('span', {
    staticClass: "no-style-override11"
  }, [_vm._v("Raptor’s Ridge")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override"
  }, [_c('span', {
    staticClass: "no-style-override11"
  }, [_vm._v("Misery Ridge")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override"
  }, [_c('span', {
    staticClass: "no-style-override11"
  }, [_vm._v("Faraway Ridge")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override"
  }, [_c('span', {
    staticClass: "no-style-override11"
  }, [_vm._v("Snowfall Ridge")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override"
  }, [_c('span', {
    staticClass: "no-style-override11"
  }, [_vm._v("Emerald Ridge")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override"
  }, [_c('span', {
    staticClass: "no-style-override12"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "heading-1-317-0-override"
  }, [_c('span', {
    staticClass: "no-style-override13"
  }, [_vm._v("The Max Blake Western series:")])]), _vm._v(" "), _c('p', {
    staticClass: "heading-1-317-0-override"
  }, [_c('span', {
    staticClass: "no-style-override13"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "heading-2-361-0-override"
  }, [_c('span', {
    staticClass: "no-style-override14"
  }, [_vm._v("The Killing Trail")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override"
  }, [_c('span', {
    staticClass: "no-style-override11"
  }, [_vm._v("Trail of Revenge")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override"
  }, [_c('span', {
    staticClass: "no-style-override11"
  }, [_vm._v("Trail to Redemption")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override"
  }, [_c('span', {
    staticClass: "no-style-override11"
  }, [_vm._v("Trail to Dead Man’s Gulch")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override"
  }, [_c('span', {
    staticClass: "no-style-override11"
  }, [_vm._v("Trail from Crooked River")]), _c('span', {
    staticClass: "no-style-override15"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "calibre_pb_4"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fccba630","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/AlsoBy1.vue
// module id = 66
// module chunks = 0